import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const Sweetalert = {
  confirm(data, dataPress) {
    MySwal.fire({
      title: data.title,
      text: data.text,
      icon: data.icon ? data.icon : "info",
      showCancelButton: data.showCancelButton ? data.showCancelButton : true,
      confirmButtonColor: data.confirmButtonColor
        ? data.confirmButtonColor
        : "#3085d6",
      cancelButtonColor: data.cancelButtonColor
        ? data.cancelButtonColor
        : "#d33",
      confirmButtonText: data.confirmButtonText,
      cancelButtonText: data.cancelButtonText,
    }).then((res) => {
      if (res.isConfirmed) {
        if (data.confirmedCallBack) {
          data.confirmedCallBack(dataPress);
        }
        if (data.confirmed) {
          MySwal.fire({
            title: data.confirmedTitle,
            text: data.confirmedText,
            icon: data.confirmedIcon,
            confirmButtonText: data.confirmedButtonText,
          });
        }
      }
    });
  },
};

export default Sweetalert;
